import { jsx } from "react/jsx-runtime";
import React from "react";
import { string, bool, oneOfType, node, arrayOf } from "prop-types";
import cx from "classnames";
const propTypes = {
  /** Adds children after `text` element. */
  children: oneOfType([
    /** Array of React elements */
    arrayOf(node),
    /** React element */
    node
  ]),
  inset: bool,
  className: string,
  prefix: string,
  /** Sets table to stretch to full width of the parent container */
  fullWidth: bool
};
const Table = (props) => {
  const {
    prefix = "",
    fullWidth,
    inset,
    className,
    children,
    ...otherProps
  } = props;
  const classes = cx(
    `${prefix}table`,
    inset && `${prefix}table--inset`,
    fullWidth && `${prefix}table--full-width`,
    className
  );
  return /* @__PURE__ */ jsx("div", { className: classes, children: /* @__PURE__ */ jsx("table", { ...otherProps, children }) });
};
Table.propTypes = propTypes;
var Table_default = Table;
export {
  Table_default as default
};
